// eslint-disable-next-line no-restricted-imports
import { css } from "@emotion/react";

import { colors } from "@atlaskit/theme";
import { token } from "@atlaskit/tokens";

export const closeModalButtonStyles = css`
    width: 30px;
    height: 30px;
    background-color: transparent;
    border: none;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: ${token("border.radius", "3px")};
    cursor: pointer;

    // Visual hack to match styles while focus is manually updated throughout demo
    &:disabled {
        color: ${colors.N0};
    }

    &:hover,
    &:focus {
        background-color: ${token("color.interaction.hovered", colors.N0)};
    }
`;
